import { Component, effect } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { SidemenuComponent } from './shared/components/sidemenu/sidemenu.component';
import { SidebarService } from './shared/services/sidebar.service';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { CommonService } from './shared/services/common.service';
import { PublicPortalComponent } from './pages/public-portal/public-portal.component';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, SidemenuComponent, CommonModule, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'apcrda';
  isSidemenuOpen = false;
  isloggedIn: any = false;
  isSidemenuOpenMobile = false;
  isMobileView: boolean = false;
  showSidebar: boolean = true
  isportal: any | null;

  constructor(private sidebarService: SidebarService,
    public router: Router,
    private commonService: CommonService) {
    this.sidebarService.sidebarState$.subscribe(state => {
      this.isSidemenuOpen = state;
    });

    effect(() => {
      this.isMobileView = this.commonService.getIsMobile();
      this.subscribeToSidebar()
    });
  }


  ngOnInit() {
    if (typeof localStorage !== 'undefined') {
      this.isportal = localStorage.getItem('isportal') === 'true';
      this.isloggedIn = localStorage.getItem('loggedIn') === 'true';
    }
    this.subscribeRouterEvents()
    this.subscribeToSidebar()
  }
  ngOnChanges() {
    if (typeof localStorage !== 'undefined') {
      this.isportal = localStorage.getItem('isportal') === 'true';
      this.isloggedIn = localStorage.getItem('loggedIn') === 'true';
      console.log('Changes detected in AppComponent - isportal:', this.isportal, 'isloggedIn:', this.isloggedIn);
    }
  }
  subscribeRouterEvents() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (typeof localStorage !== 'undefined') {
          this.isloggedIn = localStorage.getItem("loggedIn") === 'true';
          this.isportal = ((event.urlAfterRedirects.includes('/portal')) && localStorage.getItem('isportal') === 'true') ||((event.urlAfterRedirects.includes('/lps')) && localStorage.getItem('isportal') === 'true');
        }
  

        // Handle Sidebar Visibility based on route data
        let currentRoute = this.router.routerState.root;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        // Subscribe to data of the current activated route
        currentRoute.data.subscribe(data => {
          if (data['hideSidebar']) {
            this.showSidebar = false;
          } else {
            this.showSidebar = this.isMobileView ? this.isSidemenuOpenMobile : true; // Default behavior
          }
        });
      }
    })
  }


  subscribeToSidebar() {
    this.sidebarService.sidebarMobileState$.subscribe(state => {
      this.isSidemenuOpenMobile = state;
      this.showSidebar = this.isMobileView ? this.isSidemenuOpenMobile : true;
    });
  }


}
